export const SECOUND_SEMESTER_COURSE_ROUTE = "/second-semester-course";